// @flow

type RGB = [number, number, number];

/*
   Ordered list of path color names and values.

   As the user picks new path steps, we cycle thru this list in order
   to assign the default color for a path.

   We're using rgb values, so that we can use rgba() to assign
   transparent backgrounds with an opacity (alpha value).
 */
const PathColors: Array<{ name: string, value: RGB }> = [
  { name: 'Heroine Blue', value: [73, 157, 243] },
  { name: 'Peru', value: [205, 133, 63] },
  { name: 'Yellow Green', value: [154, 205, 50] },
  { name: 'Dark Magenta', value: [139, 0, 139] },
  { name: 'Dark Olive Green', value: [85, 107, 47] },
  { name: 'Light Slate Gray', value: [119, 136, 153] },
  { name: 'Dark Salmon', value: [233, 150, 122] },
  { name: 'Dark Slate Gray', value: [47, 79, 79] },
  { name: 'Dark Sea Green', value: [143, 188, 143] },
  { name: 'Zapier Orange', value: [251, 75, 32] },
];

export default PathColors;
